var map = {
	"./arrow.svg": 8218,
	"./building--active.svg": 734,
	"./building.svg": 4597,
	"./cash-stack--active.svg": 4704,
	"./cash-stack.svg": 5458,
	"./cloud--active.svg": 2875,
	"./cloud.svg": 6655,
	"./events--active.svg": 2345,
	"./events.svg": 813,
	"./gear--active.svg": 9198,
	"./gear.svg": 3107,
	"./geozones--active.svg": 4529,
	"./geozones.svg": 2359,
	"./integration--active.svg": 4465,
	"./integration.svg": 338,
	"./journal-medical--active.svg": 8826,
	"./journal-medical.svg": 1761,
	"./people--active.svg": 9887,
	"./people.svg": 6519,
	"./roles--active.svg": 312,
	"./roles.svg": 9805,
	"./terminal--active.svg": 2709,
	"./terminal.svg": 9467,
	"./text-indent-left--active.svg": 8789,
	"./text-indent-left.svg": 9883,
	"./wallet2--active.svg": 6577,
	"./wallet2.svg": 2133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 537;